import { formatDistanceToNow } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';

export const formatFollowerCount = (count: number): string => {
  if (count >= 1000000) {
    const millions = count / 1000000;
    const decimal = millions - Math.floor(millions);
    return decimal < 0.1 ? `${Math.floor(millions)}M` : `${millions.toFixed(1)}M`;
  }
  if (count >= 1000) {
    const thousands = count / 1000;
    const decimal = thousands - Math.floor(thousands);
    return decimal < 0.1 ? `${Math.floor(thousands)}K` : `${thousands.toFixed(1)}K`;
  }
  return count.toLocaleString();
};

export const formatNumberWithCommas = (num: number): string => {
  return num.toLocaleString();
};

export const calculateFollowerToFollowingRatio = (followers: number, following: number): string => {
  if (following === 0) return '∞';
  const ratio = followers / following;
  if (ratio >= 100) return ratio.toFixed(0);
  if (ratio >= 10) return ratio.toFixed(1);
  return ratio.toFixed(2);
};

export const formatRelativeTime = (timestamp: string, language: 'pl' | 'en' = 'pl'): string => {
  try {
    const date = new Date(timestamp);
    return formatDistanceToNow(date, { 
      addSuffix: false,
      locale: language === 'pl' ? pl : enUS 
    });
  } catch {
    return language === 'pl' ? 'Nieznana' : 'Unknown';
  }
};

export const formatBiography = (bio: string | null): string => {
  if (!bio) return '';
  return bio.replace(/\n/g, '<br>');
};